import React, { forwardRef } from 'react'

import { IconProps } from './types'

const CloudUpload = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke || color || 'currentColor'}
      {...props}
    >
      <path d="M4.5 11.5C3.5 11.5 1.5 10.9 1.5 8.5C1.5 6.1 3.5 5.5 4.5 5.5C4.5 4.33333 5.2 2 8 2C10.8 2 11.5 4.33333 11.5 5.5C12.5 5.5 14.5 6.1 14.5 8.5C14.5 10.9 12.5 11.5 11.5 11.5M6 10L8 8M8 8L10 10M8 8V14" />
    </svg>
  ),
)
CloudUpload.displayName = 'CloudUpload'

export default CloudUpload
